//
// Timing function
//
export const decelerationCurveTiming = 'cubic-bezier(0.0, 0.0, 0.2, 1)';
export const standardCurveTiming = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
export const accelerationCurveTiming = 'cubic-bezier(0.4, 0.0, 1, 1)';
export const sharpCurveTiming = 'cubic-bezier(0.4, 0.0, 0.6, 1)';

// shortcuts
export const easeOut = decelerationCurveTiming;
export const easeInOut = standardCurveTiming;
export const easeIn = accelerationCurveTiming;

//
// Duration
//
export const standardDuration = '150ms';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/sharedStyle/animation.ts